module.exports = __webpack_public_path__ + "static/img/image-000.feb6eb7a.jpeg";